import { render, staticRenderFns } from "./edit-assignment-files.html?vue&type=template&id=4c819040&scoped=true&"
import script from "./edit-assignment-files.js?vue&type=script&lang=js&"
export * from "./edit-assignment-files.js?vue&type=script&lang=js&"
import style0 from "./edit-assignment-files.css?vue&type=style&index=0&id=4c819040&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c819040",
  null
  
)

export default component.exports